import { render, staticRenderFns } from "./PushNotificationModal.vue?vue&type=template&id=72788c1e&scoped=true&lang=pug&"
import script from "./PushNotificationModal.vue?vue&type=script&lang=js&"
export * from "./PushNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationModal.vue?vue&type=style&index=0&id=72788c1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72788c1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VDialog,VFlex,VForm,VLayout,VTextField,VTextarea})
